module.exports = __webpack_public_path__ + "img/logout.4126b0fb.svg";